(function (root) {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const flavorKey = value => normalize(value).replace(/\b(novo|nova|pack)\b/g, '').replace(/\b\d+\s*(g|kg|ml|un|unidades)\b/g, '').replace(/\s+/g, ' ').trim();
  const rank = {manual:0, line:1, auto:2, fallback:3};
  function select(candidates, config = {}) {
    const seen = new Set([String(config.currentId)]);
    const excluded = new Set((config.excludedIds || []).map(String));
    const allowedCampaign = new Set((config.campaignIds || []).map(String));
    const siblings = new Set(config.siblingHandles || []);
    const contents = String(config.contents || '').split('||').map(row => flavorKey(row.split('::')[1])).filter(Boolean);
    const blockedWords = String(config.blockedWords ?? 'vip,exclusivo,exclusiva').split(',').map(normalize).filter(Boolean);
    const sorted = candidates.slice().sort((a,b) => (rank[a.source] ?? 9) - (rank[b.source] ?? 9));
    const result = [];
    const limit = Math.min(10, Math.max(1, Number(config.limit) || 8));
    for (const item of sorted) {
      const id = String(item.id);
      if (seen.has(id) || excluded.has(id) || !item.available || Number(item.price) <= 0 || item.giftCard) continue;
      if (config.onlyManual && item.source !== 'manual') continue;
      if (config.auto === false && item.source === 'auto') continue;
      if (siblings.has(item.handle)) continue;
      const text = normalize(`${item.handle} ${item.title} ${item.tags || ''}`);
      if (/\b(vip|exclusivo|exclusiva|exclusivos|exclusivas|hidden)\b/.test(text)) continue;
      if (!item.isKit && /\b(brinde|gift|amostra)\b/.test(text)) continue;
      if (!allowedCampaign.has(id) && blockedWords.some(word => (` ${text} `).includes(` ${word} `))) continue;
      if (config.isKit && config.avoidOtherKits && item.isKit) continue;
      if (config.isKit && config.avoidKitContents) {
        const keys = [flavorKey(item.title),flavorKey(item.handle)];
        if (contents.some(content => keys.includes(content))) continue;
      }
      seen.add(id);
      result.push(item);
      if (result.length >= limit) break;
    }
    return result;
  }
  const api = {select, flavorKey};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.HolyRecommendationRules = api;
})(typeof window === 'undefined' ? {} : window);
